export type PaysafeEnvironment = "TEST" | "LIVE";
export type PaysafeFieldName = "cardNumber" | "expiryDate" | "cvv";

export interface PaysafeFieldOptions {
  selector: string;
  placeholder: string;
}
export interface PaysafeOptions {
  environment: PaysafeEnvironment;
  fields: Record<PaysafeFieldName, PaysafeFieldOptions>;
}

export interface PaysafeResult {
  token: string;
}

export interface PaysafeValidationEvent {
  target: {
    fieldName: string;
  };
}

export interface PaysafeValidation {
  valid: (
    callback: (eventInstance: unknown, event: PaysafeValidationEvent) => void
  ) => void;
  invalid: (
    callback: (eventInstance: unknown, event: PaysafeValidationEvent) => void
  ) => void;
}

export interface PaysafeInstance {
  fields: (fields: string) => PaysafeValidation;
  tokenize: (
    callback: (
      instance: PaysafeInstance,
      error: unknown,
      result: PaysafeResult
    ) => void
  ) => void;
}

export interface Paysafe {
  fields: {
    setup: (
      apiKey: string,
      options: PaysafeOptions,
      callback: (instance: PaysafeInstance, error: unknown) => void
    ) => void;
  };
}

export class Paysafe {
  private static readonly paysafe = window.paysafe;
  private static instance: PaysafeInstance | null = null;
  private static champs: { [champ: string]: boolean } = {
    CardNumber: false,
    ExpiryDate: false,
    Cvv: false,
  };
  private static onValidate: (val: boolean) => void;
  private static validate = (): boolean =>
    Object.values(Paysafe.champs).every((elem) => elem === true);

  public static valide: boolean = false;

  public static async configuration(
    apiKey: string,
    options: PaysafeOptions,
    onValidate: (val: boolean) => void
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      Paysafe.paysafe.fields.setup(apiKey, options, (instance, error) => {
        if (error) {
          return reject(error);
        }

        Paysafe.instance = instance;
        Paysafe.onValidate = onValidate;

        Paysafe.instance
          .fields("cvv cardNumber expiryDate")
          .valid((_, event) => {
            Paysafe.champs[event.target.fieldName] = true;

            Paysafe.valide = Paysafe.validate();
            Paysafe.onValidate(Paysafe.valide);
          });

        Paysafe.instance
          .fields("cvv cardNumber expiryDate")
          .invalid((_, event) => {
            Paysafe.champs[event.target.fieldName] = false;

            Paysafe.valide = Paysafe.validate();
            Paysafe.onValidate(Paysafe.valide);
          });

        return resolve();
      });
    });
  }

  public static async jeton(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (Paysafe.instance === null) {
        return reject(
          "La librairie doit préalablement être configurée pour pouvoir récupérer le jeton PaySafe"
        );
      }

      Paysafe.instance.tokenize((_, error, result) => {
        if (error) {
          return reject(error);
        } else {
          return resolve(result.token);
        }
      });
    });
  }
}
